import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';

const OtherSettings = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    account_id: '',
    pwcta: '',
    pwicn: '',
    pwtxt: '',
    pwbpos: 'bottom',
    pwbt: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // success or danger

  // Use effect to set account ID from params or fallback
  useEffect(() => {
    const id = accountId || window.location.pathname.split('/').pop();
    setFormData(prev => ({ ...prev, account_id: id }));
    console.log('Account ID:', id);
  }, [accountId]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
       const token = localStorage.getItem("token");
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/otherSettings`, formData, {
        headers: {
             Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          
          }
      });

      setMessage('Settings saved successfully!');
      setMessageType('success');
              // Redirect after 2 seconds
        setTimeout(() => {
          navigate(-1); // Redirect to publisher list page
        }, 2000);

      // Optionally reset form (keeping account_id)
      setFormData({
        account_id: formData.account_id,
        pwcta: '',
        pwicn: '',
        pwtxt: '',
        pwbpos: 'bottom',
        pwbt: '',
      });
    } catch (error) {
      console.error('Error:', error);
      const errorMsg = error.response?.data?.message || 'Failed to save settings.';
      setMessage(`Error: ${errorMsg}`);
      setMessageType('danger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: '600px' }}>
      <h3>Other Settings</h3>
            {message && (
        <div className={`alert mt-3 alert-${messageType}`} role="alert">
          {message}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="account_id" className="form-label">Account ID</label>
          <input
            type="text"
            className="form-control"
            id="account_id"
            name="account_id"
            value={formData.account_id}
            onChange={handleChange}
            readOnly
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pwcta" className="form-label">Powered by CTA (URL)</label>
          <input
            type="text"
            className="form-control"
            id="pwcta"
            name="pwcta"
            value={formData.pwcta}
            onChange={handleChange}
            
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pwicn" className="form-label">Powered by Icon</label>
          <input
            type="text"
            className="form-control"
            id="pwicn"
            name="pwicn"
            value={formData.pwicn}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pwtxt" className="form-label">Powered by Text</label>
          <input
            type="text"
            className="form-control"
            id="pwtxt"
            name="pwtxt"
            value={formData.pwtxt}
            onChange={handleChange}
            
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pwbpos" className="form-label">Powered by Position</label>
          <select
            className="form-select"
            id="pwbpos"
            name="pwbpos"
            value={formData.pwbpos}
            onChange={handleChange}
            
          >
            <option value="bottom">Bottom</option>
            <option value="top">Top</option>
          </select>
        </div>

        <div className="mb-3">
          <label htmlFor="pwbt" className="form-label">Powered by Timer</label>
          <input
            type="text"
            className="form-control"
            id="pwbt"
            name="pwbt"
            value={formData.pwbt}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Saving...' : 'Save Settings'}
        </button>

        <button className="btn btn-secondary mx-3" onClick={() => navigate(-1)}>Cancel</button>
      </form>
    </div>
  );
};

export default OtherSettings;
